import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-633cc0e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "vrt-body"
}
const _hoisted_3 = { class: "vrt-heading-block" }
const _hoisted_4 = { class: "vrt-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vrt-subtitle" }, " We’ll send you Red Tag updates for this trailer ", -1))
const _hoisted_6 = { class: "vrt-field" }
const _hoisted_7 = {
  key: 1,
  class: "vrt-field-hint",
  role: "status"
}
const _hoisted_8 = {
  key: 2,
  class: "vrt-field-error",
  role: "alert"
}
const _hoisted_9 = {
  key: 0,
  class: "vrt-actions"
}
const _hoisted_10 = {
  key: 1,
  class: "vrt-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_VirtualRedTagMethodIcon = _resolveComponent("VirtualRedTagMethodIcon")!
  const _component_fbx_input = _resolveComponent("fbx-input")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader, { outlined: "" }),
    (_ctx.assessmentId && _ctx.notificationMethod)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VirtualRedTagMethodIcon, {
              method: _ctx.isEmail ? 'email' : 'text',
              class: "vrt-method-icon"
            }, null, 8, ["method"]),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.isDeadEnd)
              ? (_openBlock(), _createBlock(_component_fbx_input, {
                  ref: "contactInput",
                  key: _ctx.notificationMethod,
                  id: "vrt-notification-contact",
                  label: _ctx.inputLabel,
                  type: _ctx.isEmail ? 'text' : 'tel',
                  trim: _ctx.isEmail,
                  "onUpdate:modelValue": _ctx.onContactChanged
                }, null, 8, ["label", "type", "trim", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.fieldHint)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.fieldHint), 1))
              : _createCommentVNode("", true),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isDeadEnd)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_fbx_button, {
                  "button-text": "Return to Pointe",
                  theme: "primary",
                  onClick: _ctx.navigateToWelcome
                }, null, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_fbx_button, {
                  "button-text": "Confirm",
                  theme: "primary",
                  disabled: !_ctx.canConfirm,
                  "show-loading": _ctx.isSaving,
                  onClick: _ctx.onConfirm
                }, null, 8, ["disabled", "show-loading", "onClick"]),
                _createVNode(_component_fbx_button, {
                  "button-text": "Go Back",
                  theme: "primaryOutline",
                  class: "italic",
                  disabled: _ctx.isSaving,
                  onClick: _ctx.navigateBack
                }, null, 8, ["disabled", "onClick"])
              ])),
          (!_ctx.isDeadEnd)
            ? (_openBlock(), _createBlock(_component_fbx_button, {
                key: 2,
                "button-text": "Return to Pointe",
                theme: "link",
                class: "italic vrt-return-link",
                disabled: _ctx.isSaving,
                onClick: _ctx.navigateToWelcome
              }, null, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}